import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from "@/store"
import VueI18n from "vue-i18n";

import "@/components/index"

import messages from "@/translation/messages";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: typeof lang !== "undefined" ? lang : 'de', // set locale
    fallbackLocale: 'en',
    messages,
})


Vue.config.productionTip = false
Vue.prototype.$configuratorRouter = router;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js